/**
 * Bascules de dev.
 *
 * C'est un petit store observable et non un objet de props : basculer le grain
 * ou le feathering doit repeindre le canvas sans remonter le moteur, sinon on
 * perdrait le dessin en cours : or comparer avec et sans, sur le meme dessin,
 * est precisement l'interet de ces bascules.
 */
export interface DevOptions {
  /** Surligne le rect de la zone, pour verifier le cadrage. */
  readonly showZoneRect: boolean;
  /** Grain sur le tableau composite. */
  readonly grain: boolean;
  /** Adoucissement du bord de la zone. */
  readonly feather: boolean;
  /**
   * Sonde de position : marque le point BRUT du pointeur et le dernier point
   * RETENU. Sert a trancher les questions de precision par la mesure plutot que
   * par l'impression, notamment au doigt ou la main cache la reponse.
   */
  readonly touchProbe: boolean;
}

const DEFAULTS: DevOptions = {
  showZoneRect: false,
  grain: true,
  feather: true,
  touchProbe: false,
};

export class DevOptionsStore {
  private current: DevOptions = DEFAULTS;
  private readonly listeners = new Set<() => void>();

  get value(): DevOptions {
    return this.current;
  }

  set(patch: Partial<DevOptions>): void {
    this.current = { ...this.current, ...patch };
    for (const listener of this.listeners) listener();
  }

  toggle(key: keyof DevOptions): void {
    this.set({ [key]: !this.current[key] });
  }

  subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  /** Pour useSyncExternalStore. */
  getSnapshot = (): DevOptions => this.current;
}
